module.exports = __webpack_public_path__ + "c1fe2289437a291f89f8604c8027b808.svg";